import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useGoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip tracking on localhost
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      return;
    }

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname,
        page_title: document.title
      });
    }
  }, [location]);
};

// Export function to track custom events
export const trackEvent = (eventName, parameters = {}) => {
  // Skip tracking on localhost
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    console.log('GA Event (localhost):', eventName, parameters);
    return;
  }

  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, parameters);
  }
};

export default useGoogleAnalytics;
